/*
Copyright 2022 Fondazione Bruno Kessler
Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
except in compliance with the Licence.

You may obtain a copy of the Licence at:
http://ec.europa.eu/idabc/eupl.html

Unless required by applicable law or agreed to in writing, software distributed under 
the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF 
ANY KIND, either express or implied. See the Licence for the specific language 
governing permissions and limitations under the Licence.
*/
import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {CommonState} from "@app/store/common/common.state";
import {AlertController, ModalController} from "@ionic/angular";
import {Store} from "@ngxs/store";
import {GetTCGroups, VideoChatService} from "@trec/api";
import {ModalAddTeleconsultoComponent} from "../../../../patient-personal-data/components/modal-add-teleconsulto/modal-add-teleconsulto.component";
import {ModalDetailTeleconsultoComponent} from "../../../../patient-personal-data/components/modal-detail-teleconsulto/modal-detail-teleconsulto.component";

@Component({
  selector: "c3-config-teleconsulto",
  templateUrl: "./config-teleconsulto.component.html",
  styleUrls: ["./config-teleconsulto.component.scss"],
  standalone: false
})
export class ConfigTeleconsultoComponent implements OnInit {
  teleconsultoList: GetTCGroups | null = null;
  trecUserId;
  patientId;
  constructor(
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private cd: ChangeDetectorRef,
    private store: Store,
    private videoChatService: VideoChatService
  ) { }

  ngOnInit(): void {
    this.patientId = this.store.selectSnapshot(CommonState.patientId);
    this.trecUserId = this.store.selectSnapshot(CommonState.userId);
    this.getTeleconsultoList();
  }

  async openDetail(item) {
    console.log(item);
    const modal = await this.modalController.create({
      component: ModalDetailTeleconsultoComponent,
      componentProps: {
        name: item.groupName,
        participants: item.physicians,
        id: item.groupId,
      },
      cssClass: "teleconsulto-modal",
    });
    modal.onDidDismiss().then((data) => {
      this.getTeleconsultoList();
      this.cd.markForCheck();
    });
    return await modal.present();
  }

  async delete(item) {
    const alert = await this.alertCtrl.create({
      header: "Elimina Gruppo",
      message: "Vuoi veramente cancellare il gruppo?",
      buttons: [
        {text: "Annulla", role: "cancel"},
        {text: "Elimina", handler: () => this.deleteGroup(item)},
      ],
    });

    await alert.present();
  }

  deleteGroup(item) {
    this.videoChatService.deleteTCgroup(this.patientId, item.groupId, item.groupName).subscribe(
      (data) => {
        console.log(data);
        this.getTeleconsultoList();
      },
      (err) => {
        console.error(err);
      }
    );
  }

  async getTeleconsultoList() {
    this.videoChatService.getTCGroups(this.patientId).subscribe(
      (data) => {
        if (data) {
          console.log(data);
          this.teleconsultoList = data;
          for (let i = 0; i < this.teleconsultoList.physiciansGroups.length; i++) {
            for (let j = 0; j < this.teleconsultoList.physiciansGroups[i].physicians.length; j++) {
              if (
                this.teleconsultoList.physiciansGroups[i].physicians[j].trecUserId ===
                this.trecUserId
              ) {
                this.teleconsultoList.physiciansGroups[i].isPartOf = true;
              }
            }
          }
        } else {
          this.teleconsultoList = null;
        }
        this.cd.markForCheck();
      },
      (err) => {
        console.log(err);
        this.teleconsultoList = null;
        this.cd.markForCheck();
      }
    );
  }

  async addTeam() {
    const modal = await this.modalController.create({
      component: ModalAddTeleconsultoComponent,
      cssClass: "teleconsulto-modal-add",
    });

    modal.onDidDismiss().then((data) => {
      this.getTeleconsultoList();
    });
    return await modal.present();
  }
}
